import { useEffect } from "react";

export default function useBackground(url: string, enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) {
      document.documentElement.style.background = "";
      return;
    }

    document.documentElement.style.background = `
      center/cover url(${url}) fixed
    `;

    return () => {
      document.documentElement.style.background = "";
    };
  }, [url, enabled]);
}
